import { jsx as o } from "react/jsx-runtime";
import { c as t } from "../../../clsx-OuTLNxxd.js";
import _ from "react";
import { useCarousel as C } from "./carousel.hook.js";
import { defaultBreakpoints as N } from "./types.js";
const R = "_carousel_u43l3_29", l = {
  carousel: R,
  "carousel-content": "_carousel-content_u43l3_33",
  "gap-0": "_gap-0_u43l3_47",
  "gap-1": "_gap-1_u43l3_50",
  "gap-2": "_gap-2_u43l3_53",
  "gap-3": "_gap-3_u43l3_56",
  "gap-4": "_gap-4_u43l3_59",
  "gap-5": "_gap-5_u43l3_62",
  "gap-6": "_gap-6_u43l3_65",
  "gap-7": "_gap-7_u43l3_68",
  "gap-8": "_gap-8_u43l3_71",
  "gap-9": "_gap-9_u43l3_74",
  "gap-10": "_gap-10_u43l3_77",
  "gap-11": "_gap-11_u43l3_80",
  "gap-12": "_gap-12_u43l3_83",
  "gap-14": "_gap-14_u43l3_86",
  "gap-16": "_gap-16_u43l3_89",
  "gap-18": "_gap-18_u43l3_92",
  "gap-20": "_gap-20_u43l3_95",
  "gap-24": "_gap-24_u43l3_98",
  "gap-28": "_gap-28_u43l3_101",
  "gap-32": "_gap-32_u43l3_104",
  "gap-36": "_gap-36_u43l3_107",
  "gap-40": "_gap-40_u43l3_110",
  "gap-44": "_gap-44_u43l3_113",
  "gap-48": "_gap-48_u43l3_116",
  "gap-52": "_gap-52_u43l3_119",
  "gap-56": "_gap-56_u43l3_122",
  "gap-60": "_gap-60_u43l3_125",
  "gap-64": "_gap-64_u43l3_128",
  "gap-72": "_gap-72_u43l3_131",
  "gap-80": "_gap-80_u43l3_134",
  "gap-96": "_gap-96_u43l3_137",
  "padding-element-wrapper": "_padding-element-wrapper_u43l3_140",
  "dialog-overlay-show": "_dialog-overlay-show_u43l3_1",
  "dialog-content-show": "_dialog-content-show_u43l3_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_u43l3_1"
}, k = ({
  children: p,
  className: r = "",
  paddingElementWrapper: e = !1,
  gap: g = "8",
  itemsPerBreakpoint: s = N,
  onNavigationStateChange: n,
  ...c
}, i) => {
  const { carouselRef: u, shouldDisplayPrev: d, shouldDisplayNext: m, scrollPrev: f, scrollNext: h, getItemWidth: w } = C(
    p,
    {
      itemsPerBreakpoint: s,
      paddingElementWrapper: e,
      onNavigationStateChange: n
    }
  ), x = _.Children.map(p, (a, v) => _.isValidElement(a) ? _.cloneElement(a, {
    style: {
      ...a.props.style,
      width: `${w(v)}px`,
      flexShrink: 0
    }
  }) : a);
  _.useImperativeHandle(i, () => ({
    scrollNext: h,
    scrollPrev: f,
    shouldDisplayNext: m,
    shouldDisplayPrev: d,
    carouselElement: u.current
  }));
  const y = t(l.carousel, r);
  return /* @__PURE__ */ o("div", { className: y, ...c, children: /* @__PURE__ */ o(
    "ul",
    {
      ref: u,
      className: t(
        l["carousel-content"],
        e && l["padding-element-wrapper"],
        g && l[`gap-${g}`]
      ),
      children: x
    }
  ) });
}, $ = _.forwardRef(k);
export {
  $ as Carousel
};
